/**
 * Shared tooltip positioning utility.
 * Used by GlossaryTip and SalaryTip hooks.
 */
export function createTooltip(el, buildContent, options = {}) {
  let tip = null
  let touchTimeout = null
  const gap = options.gap || 8

  const show = () => {
    if (tip) return
    const rect = el.getBoundingClientRect()

    tip = document.createElement("div")
    tip.className = options.className || "fixed z-[200] bg-base-200 border border-base-300 rounded-lg shadow-xl p-3 text-sm pointer-events-none"
    if (options.width) tip.style.width = options.width
    tip.style.maxWidth = "calc(100vw - 2rem)"
    tip.style.fontFamily = "system-ui, sans-serif"
    tip.style.whiteSpace = options.whiteSpace || "normal"
    if (options.wordWrap !== false) tip.style.wordWrap = "break-word"
    tip.innerHTML = buildContent(el)
    document.body.appendChild(tip)

    // Position below the element, clamped to viewport
    const tipRect = tip.getBoundingClientRect()
    let left = rect.left + rect.width / 2 - tipRect.width / 2
    let top = rect.bottom + gap

    // Clamp horizontally
    left = Math.max(8, Math.min(left, window.innerWidth - tipRect.width - 8))
    // If no room below, show above
    if (top + tipRect.height > window.innerHeight - 8) {
      top = rect.top - tipRect.height - gap
    }

    tip.style.left = left + "px"
    tip.style.top = top + "px"
  }

  const hide = () => {
    if (tip) { tip.remove(); tip = null }
    if (touchTimeout) { clearTimeout(touchTimeout); touchTimeout = null }
  }

  el.addEventListener("mouseenter", show)
  el.addEventListener("mouseleave", hide)
  el.addEventListener("touchstart", () => {
    if (tip) { hide() } else { show(); touchTimeout = setTimeout(hide, 3000) }
  }, { passive: true })

  return () => {
    el.removeEventListener("mouseenter", show)
    el.removeEventListener("mouseleave", hide)
    hide()
  }
}
